<template>
  <div>
    <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <!-- <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                @addForm="addForm"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol lg="3">
            <div class="form-group">
              <label for="code">Code</label>
              <model-select
                class="form-control"
                id="code"
                :options="CodeList"
                v-model="$v.menuForm.code.$model"
                :isError="$v.menuForm.code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div v-if="$v.menuForm.code.$invalid" class="invalid-feedback-custom">
                Code should be filled.
              </div>
            </div>
          </CCol>
          <CCol lg="3">
            <CInput
              label="Name"
              invalid-feedback="Name should be filled"
              v-model="$v.menuForm.name.$model"
              :is-valid="!$v.menuForm.name.$invalid"
            />
          </CCol>
          <CCol lg="3">
            <div class="form-group">
              <label for="status">Is Title</label>
              <model-select
                class="form-control"
                id="title"
                :options="StatusList"
                v-model="$v.menuForm.is_title.$model"
                :isError="$v.menuForm.is_title.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div v-if="$v.menuForm.is_title.$invalid" class="invalid-feedback-custom">
                Is Title should be filled.
              </div>
            </div>
          </CCol>
          <CCol lg="3">
            <div class="form-group">
              <label for="is_agent">For Menu Agent</label>
              <model-select
                class="form-control"
                id="is_agent"
                :options="StatusList"
                v-model="$v.menuForm.is_agent.$model"
                :isError="$v.menuForm.is_agent.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div v-if="$v.menuForm.is_agent.$invalid" class="invalid-feedback-custom">
                For Menu Agent should be filled.
              </div>
            </div>
          </CCol>
         
        </CRow>
        <CRow>
          
          <CCol lg="3">
            <div class="form-group">
              <label for="icon">Icon</label>
              <model-select
                class="form-control"
                id="icon"
                :options="IconList"
                v-model="$v.menuForm.icon.$model"
                :isError="$v.menuForm.icon.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div v-if="$v.menuForm.icon.$invalid" class="invalid-feedback-custom">
                Icon should be filled.
              </div>
            </div>
          </CCol>
           <CCol lg="3">
            <CInput
              label="url"
              invalid-feedback="Url should be filled"
              v-model="$v.menuForm.url.$model"
              :is-valid="!$v.menuForm.url.$invalid"
            />
          </CCol>
          <CCol lg="3">
            <div class="form-group">
              <label for="code">Parent</label>
              <model-select
                class="form-control"
                id="parent"
                :options="ParentList"
                v-model="$v.menuForm.parent.$model"
                :isError="$v.menuForm.parent.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>
          <CCol lg="3">
            <div class="form-group">
              <CInput
                label="Ordering"
                invalid-feedback="Ordering should be filled"
                required
                v-model="$v.menuForm.ordering.$model"
                :is-valid="!$v.menuForm.ordering.$invalid"
              />
            </div>
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.menuForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

import Loading from "@/templates/Loading.vue";
// import TableButton from "@/templates/TableButton";
// import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Menu",
  components: { Loading, GlobalTable },
  data() {
    return {
      title: "Menu",
      // source: {
      //   localdata: [],
      //   datafields: [
      //     { name: "id", type: "number" },
      //     { name: "text", type: "string" },
      //     { name: "icon", type: "string" },
      //     { name: "url", type: "string" },
      //     { name: "ordering", type: "string" },
      //     { name: "parent", type: "string" },
      //   ],
      //   datatype: "json",
      // },
      // editrow: -1,

      // fields: [
      //   {
      //     datafield: "text",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Name",
      //   },
      //   {
      //     datafield: "icon",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Icon",
      //   },
      //   {
      //     datafield: "url",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "URL",
      //   },
      //   {
      //     datafield: "ordering",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Ordering",
      //   },
      //   {
      //     datafield: "parent",
      //     columntype: "textbox",
      //     filtertype: "textbox",
      //     text: "Parent",
      //   },
      //   {
      //     text: "Action",
      //     align: "center",
      //     name: "EditAction",
      //     columntype: "button",
      //     width: 60,
      //     sortable: false,
      //     filtertype: "none",
      //     menu: false,
      //     cellsrenderer: () => {
      //       return "Edit";
      //     },
      //     buttonclick: (row) => {
      //       let dataRecord = this.$refs.myGrid.getrowdata(row);
      //       let path = this.$route.path.split("/");

      //       this.$router.push({
      //         path: path.hasOwnProperty("2")
      //           ? path[2] + "/detail/" + dataRecord.id
      //           : "detail/" + dataRecord.id,
      //       });
      //     },
      //   },
      // ],

      fields: [
        { key: "text", label: "Name", sorter: true },
        { key: "icon", label: "Icon", sorter: true },
        { key: "url", label: "URL", sorter: true },
        { key: "ordering", label: "Ordering", sorter: true },
        { key: "parent", label: "Parent", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],

      items: [],
      ParentList: [],
      StatusList: [],
      CodeList: [],
      IconList: [],
      menuForm: tableInterfaces.menu,
      isReadonly: false,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: "",

      // visibilityShow: false,
      // showNeed:false,
      // exportNeed:false,
      // localization: getLocalization("en"),
      // visibilityShow: false,
    };
  },
  validations: {
    menuForm: {
      name: { required },
      url: { },
      is_title: { required },
      is_agent: { required },
      icon: { required },
      ordering: {},
      parent: {},
      code: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
      // exportXls: function () {
      //   this.$refs.myGrid.exportdata("xls", "order");
      // },
      // exportPdf: function () {
      //   this.$refs.myGrid.exportdata("pdf", "order");
      // },
      // myListBoxOnCheckChange: function (event) {
      //   this.$refs.myGrid.beginupdate();
      //   if (event.args.checked) {
      //     this.$refs.myGrid.showcolumn(event.args.value);
      //   } else {
      //     this.$refs.myGrid.hidecolumn(event.args.value);
      //   }
      //   this.$refs.myGrid.endupdate();
      // },
      // showHide: function () {
      //   this.visibilityShow = !this.visibilityShow;
      // },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getDropdown();
      this.getMenu();
    },
    getMenu: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/add_menu/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // const temp = this.source;
            // temp.localdata = response.data.data;
            // this.items = new jqx.dataAdapter(temp);
            
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.isLoading = true;
      this.axios
        .get("console/dropdown/add_menu")
        .then((response) => {
          // console.log(response)
          if (response.data.status === 2000) {
            this.ParentList = response.data.menu;
            this.CodeList = response.data.code;
            this.StatusList = response.data.status_list;
            this.IconList = response.data.icon;
            
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isReadonly = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.isReadonly = null;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.menuForm = item;
      if (item.show === "1") {
        this.isReadonly = true;
      } else {
        this.isReadonly = false;
      }
    },
    resetForm: function () {
      for (var i in tableInterfaces.menu) {
        tableInterfaces.menu[i] = null;
      }
      this.menuForm = tableInterfaces.menu;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/master/add_menu/add", this.menuForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/add_menu/update", this.menuForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.menuForm.description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
